import ClearImageGallery from './ClearImageGallery';

export default ClearImageGallery;
